import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    msgConfirmDelete: { type: String, default: "이 리드를 삭제할까요?" },
    msgConfirmBulkDelete: { type: String, default: "%{count}건을 삭제할까요?" },
    msgModalTitleEdit: { type: String, default: "리드 편집" },
    msgModalTitleAdd: { type: String, default: "리드 추가" },
    msgSaveError: { type: String, default: "저장 실패" },
    msgImportSuccess: { type: String, default: "%{count}건 임포트 완료" },
    msgImportError: { type: String, default: "임포트 실패" },
    msgSelectedCount: { type: String, default: "%{count}건 선택됨" },
    msgEmpty: { type: String, default: "리드가 없습니다. 리드를 추가하거나 CSV를 임포트해보세요." },
    msgBtnEdit: { type: String, default: "편집" },
    msgBtnDelete: { type: String, default: "삭제" },
    msgStatusNew: { type: String, default: "신규" },
    msgStatusContacted: { type: String, default: "연락함" },
    msgStatusReplied: { type: String, default: "회신" },
    msgStatusConverted: { type: String, default: "전환" },
    msgStatusUnsubscribed: { type: String, default: "수신거부" },
    msgStatusBounced: { type: String, default: "반송" },
    campaignId: { type: Number, default: 0 },
    campaignName: { type: String, default: "" },
    campaignLeadListId: { type: Number, default: 0 },
    campaignLeadListName: { type: String, default: "" }
  }

  _interpolate(template, vars) {
    return template.replace(/%\{(\w+)\}/g, (_, k) => vars[k] !== undefined ? vars[k] : "")
  }

  connect() {
    this._leads = window._coldmailLeadsData || []
    this._leadLists = window._coldmailLeadLists || []
    this._filtered = [...this._leads]
    this._selected = new Set()

    this._render()
    this._renderLeadLists()
    this._bindEvents()
  }

  _bindEvents() {
    const q = document.getElementById("cm-search")
    const statusFilter = document.getElementById("cm-status-filter")
    const selectAll = document.getElementById("cm-select-all")
    const addBtn = document.getElementById("cm-add-btn")
    const modalClose = document.getElementById("cm-modal-close")
    const modalCancel = document.getElementById("cm-modal-cancel")
    const modalSave = document.getElementById("cm-modal-save")
    const exportBtn = document.getElementById("cm-export-btn")
    const importFile = document.getElementById("cm-import-file")
    const bulkStatusBtn = document.getElementById("cm-bulk-status-btn")
    const bulkDeleteBtn = document.getElementById("cm-bulk-delete-btn")
    const createListBtn = document.getElementById("cm-create-list-btn")
    const addSelectedToListBtn = document.getElementById("cm-add-selected-to-list-btn")
    const connectCampaignBtn = document.getElementById("cm-connect-campaign-btn")

    q?.addEventListener("input", () => this._applyFilters())
    statusFilter?.addEventListener("change", () => this._applyFilters())
    selectAll?.addEventListener("change", (e) => this._toggleAll(e.target.checked))
    addBtn?.addEventListener("click", () => this._openModal())
    modalClose?.addEventListener("click", () => this._closeModal())
    modalCancel?.addEventListener("click", () => this._closeModal())
    modalSave?.addEventListener("click", () => this._save())
    exportBtn?.addEventListener("click", () => { window.location = "/coldmail/leads/export" })
    importFile?.addEventListener("change", (e) => this._import(e.target.files[0]))
    bulkStatusBtn?.addEventListener("click", () => this._bulkStatus())
    bulkDeleteBtn?.addEventListener("click", () => this._bulkDelete())
    createListBtn?.addEventListener("click", () => this._createLeadList())
    addSelectedToListBtn?.addEventListener("click", () => this._addSelectedToLeadList())
    connectCampaignBtn?.addEventListener("click", () => this._connectSelectedToCampaign())

    document.getElementById("cm-modal")?.addEventListener("click", (e) => {
      if (e.target.id === "cm-modal") this._closeModal()
    })
  }

  _applyFilters() {
    const q = (document.getElementById("cm-search")?.value || "").toLowerCase()
    const status = document.getElementById("cm-status-filter")?.value || ""
    this._filtered = this._leads.filter(l => {
      const matchQ = !q || (l.name || "").toLowerCase().includes(q) || (l.email || "").toLowerCase().includes(q) || (l.company || "").toLowerCase().includes(q)
      const matchS = !status || l.status === status
      return matchQ && matchS
    })
    this._render()
  }

  _render() {
    const tbody = document.getElementById("cm-leads-tbody")
    if (!tbody) return
    if (this._filtered.length === 0) {
      tbody.innerHTML = `<tr><td colspan="8" class="cm__empty">${this.msgEmptyValue}</td></tr>`
      return
    }
    tbody.innerHTML = this._filtered.map(l => `
      <tr data-id="${l.id}">
        <td><input type="checkbox" class="cm__checkbox cm-row-check" data-id="${l.id}" ${this._selected.has(l.id) ? "checked" : ""}></td>
        <td style="font-weight:600;color:#111827;">${this._esc(l.name || "—")}</td>
        <td style="color:#6B7280;">${this._esc(l.email)}</td>
        <td>${this._esc(l.company || "—")}</td>
        <td>${this._esc(l.position || "—")}</td>
        <td>${this._statusBadge(l.status)}</td>
        <td style="color:#9CA3AF;font-size:13px;">${l.last_contacted_at || "—"}</td>
        <td>
          <div class="cm__row-actions">
            <button class="cm__btn-icon cm-edit-btn" data-id="${l.id}">${this.msgBtnEditValue}</button>
            <button class="cm__btn-icon cm__btn-icon--danger cm-del-btn" data-id="${l.id}">${this.msgBtnDeleteValue}</button>
          </div>
        </td>
      </tr>
    `).join("")

    tbody.querySelectorAll(".cm-row-check").forEach(cb => {
      cb.addEventListener("change", (e) => {
        const id = parseInt(e.target.dataset.id)
        e.target.checked ? this._selected.add(id) : this._selected.delete(id)
        this._updateBulkBar()
      })
    })
    tbody.querySelectorAll(".cm-edit-btn").forEach(btn => {
      btn.addEventListener("click", (e) => {
        const lead = this._leads.find(l => l.id === parseInt(btn.dataset.id))
        if (lead) this._openModal(lead)
      })
    })
    tbody.querySelectorAll(".cm-del-btn").forEach(btn => {
      btn.addEventListener("click", (e) => {
        const id = parseInt(btn.dataset.id)
        if (confirm(this.msgConfirmDeleteValue)) this._delete(id)
      })
    })
  }

  _statusBadge(status) {
    const map = {
      new: [this.msgStatusNewValue, "#DCFCE7", "#166534"],
      contacted: [this.msgStatusContactedValue, "#FEF9C3", "#854D0E"],
      replied: [this.msgStatusRepliedValue, "#DBEAFE", "#1E40AF"],
      converted: [this.msgStatusConvertedValue, "#E0E7FF", "#3730A3"],
      unsubscribed: [this.msgStatusUnsubscribedValue, "#F3F4F6", "#374151"],
      bounced: [this.msgStatusBouncedValue, "#FEE2E2", "#991B1B"]
    }
    const [label, bg, color] = map[status] || [this.msgStatusNewValue, "#DCFCE7", "#166534"]
    return `<span class="cm__badge" style="background:${bg};color:${color};">${label}</span>`
  }

  _toggleAll(checked) {
    this._filtered.forEach(l => checked ? this._selected.add(l.id) : this._selected.delete(l.id))
    document.querySelectorAll(".cm-row-check").forEach(cb => { cb.checked = checked })
    this._updateBulkBar()
  }

  _updateBulkBar() {
    const bar = document.getElementById("cm-bulk-bar")
    const count = document.getElementById("cm-selected-count")
    if (this._selected.size > 0) {
      bar?.classList.add("visible")
      if (count) count.textContent = this._interpolate(this.msgSelectedCountValue, { count: this._selected.size })
    } else {
      bar?.classList.remove("visible")
    }
  }

  _renderLeadLists() {
    const select = document.getElementById("cm-lead-list-select")
    const chips = document.getElementById("cm-list-chips")
    if (select) {
      const current = select.value
      select.innerHTML = [
        `<option value="">리스트를 선택하세요</option>`,
        ...this._leadLists.map(list => (
          `<option value="${list.id}">${this._esc(list.name)} · ${Number(list.leads_count || 0).toLocaleString()}명</option>`
        ))
      ].join("")
      if (this._leadLists.some(list => String(list.id) === String(current))) select.value = current
    }
    if (chips) {
      chips.innerHTML = this._leadLists.length
        ? this._leadLists.map(list => `<span class="cm__list-chip">${this._esc(list.name)} <strong>${Number(list.leads_count || 0).toLocaleString()}명</strong></span>`).join("")
        : `<span class="cm__list-copy">아직 만든 대상 리스트가 없습니다.</span>`
    }
  }

  _setListMessage(message, isError = false) {
    const el = document.getElementById("cm-list-message")
    if (!el) return
    el.textContent = message
    el.classList.toggle("is-error", isError)
  }

  get _csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  async _createLeadList() {
    const nameInput = document.getElementById("cm-list-name")
    const descriptionInput = document.getElementById("cm-list-description")
    const name = (nameInput?.value || "").trim()
    const description = (descriptionInput?.value || "").trim()
    if (!name) {
      this._setListMessage("리스트 이름을 입력해주세요.", true)
      nameInput?.focus()
      return
    }

    try {
      const res = await fetch("/coldmail/lead_lists", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrfToken },
        body: JSON.stringify({ lead_list: { name, description } })
      })
      const json = await res.json()
      if (!json.success) {
        this._setListMessage((json.errors || []).join(", ") || "리스트를 만들지 못했습니다.", true)
        return
      }

      this._leadLists.unshift(json.list)
      if (nameInput) nameInput.value = ""
      if (descriptionInput) descriptionInput.value = ""
      this._renderLeadLists()
      const select = document.getElementById("cm-lead-list-select")
      if (select) select.value = String(json.list.id)
      this._setListMessage(`"${json.list.name}" 리스트를 만들었습니다. 이제 리드를 체크해서 넣어주세요.`)
    } catch (error) {
      console.error("Create lead list failed:", error)
      this._setListMessage("리스트 생성 중 오류가 발생했습니다.", true)
    }
  }

  async _addSelectedToLeadList() {
    const select = document.getElementById("cm-lead-list-select")
    const leadListId = select?.value
    if (!leadListId) {
      this._setListMessage("리드를 넣을 리스트를 선택해주세요.", true)
      return
    }
    if (this._selected.size === 0) {
      this._setListMessage("아래 표에서 연결할 리드를 먼저 체크해주세요.", true)
      return
    }

    try {
      const res = await fetch(`/coldmail/lead_lists/${leadListId}/add_leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrfToken },
        body: JSON.stringify({ lead_ids: [...this._selected] })
      })
      const json = await res.json()
      if (!json.success) {
        this._setListMessage((json.errors || []).join(", ") || "리드를 리스트에 넣지 못했습니다.", true)
        return
      }

      const list = this._leadLists.find(item => String(item.id) === String(leadListId))
      if (list) list.leads_count = json.leads_count
      const count = this._selected.size
      this._selected.clear()
      this._render()
      this._renderLeadLists()
      this._updateBulkBar()
      this._setListMessage(`${count}건의 리드를 리스트에 연결했습니다. 이제 캠페인 상세에서 이 리스트를 선택하세요.`)
    } catch (error) {
      console.error("Add leads to list failed:", error)
      this._setListMessage("리드 연결 중 오류가 발생했습니다.", true)
    }
  }

  async _connectSelectedToCampaign() {
    if (!this.campaignIdValue) return
    if (this._selected.size === 0) {
      this._setListMessage("이 캠페인에 보낼 잠재고객을 먼저 체크해주세요.", true)
      return
    }

    const button = document.getElementById("cm-connect-campaign-btn")
    const originalText = button?.textContent
    if (button) {
      button.disabled = true
      button.textContent = "연결 중..."
    }

    try {
      const list = await this._ensureCampaignLeadList()
      await this._addLeadsToList(list.id, [...this._selected])
      await this._attachListToCampaign(list.id)
      window.location.href = `/coldmail/campaigns/${this.campaignIdValue}`
    } catch (error) {
      console.error("Connect campaign audience failed:", error)
      this._setListMessage(error.message || "잠재고객을 캠페인에 연결하지 못했습니다.", true)
      if (button) {
        button.disabled = false
        button.textContent = originalText
      }
    }
  }

  async _ensureCampaignLeadList() {
    if (this.campaignLeadListIdValue) {
      return {
        id: this.campaignLeadListIdValue,
        name: this.campaignLeadListNameValue || "캠페인 대상 그룹"
      }
    }

    const name = `${this.campaignNameValue || "새 캠페인"} 대상 그룹`
    const res = await fetch("/coldmail/lead_lists", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrfToken },
      body: JSON.stringify({
        lead_list: {
          name,
          description: "캠페인 잠재고객 화면에서 자동 생성됨"
        }
      })
    })
    const json = await res.json()
    if (!json.success) throw new Error((json.errors || []).join(", ") || "대상 그룹을 만들지 못했습니다.")

    this._leadLists.unshift(json.list)
    this.campaignLeadListIdValue = Number(json.list.id)
    this.campaignLeadListNameValue = json.list.name
    this._renderLeadLists()
    return json.list
  }

  async _addLeadsToList(leadListId, leadIds) {
    const res = await fetch(`/coldmail/lead_lists/${leadListId}/add_leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrfToken },
      body: JSON.stringify({ lead_ids: leadIds })
    })
    const json = await res.json()
    if (!json.success) throw new Error((json.errors || []).join(", ") || "잠재고객을 대상 그룹에 넣지 못했습니다.")

    const list = this._leadLists.find(item => String(item.id) === String(leadListId))
    if (list) list.leads_count = json.leads_count
  }

  async _attachListToCampaign(leadListId) {
    const res = await fetch(`/coldmail/campaigns/${this.campaignIdValue}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": this._csrfToken },
      body: JSON.stringify({ campaign: { coldmail_lead_list_id: leadListId } })
    })
    const json = await res.json()
    if (!json.success) throw new Error((json.errors || []).join(", ") || "캠페인에 대상 그룹을 연결하지 못했습니다.")
  }

  _openModal(lead = null) {
    document.getElementById("cm-modal-title").textContent = lead ? this.msgModalTitleEditValue : this.msgModalTitleAddValue
    document.getElementById("cm-lead-id").value = lead?.id || ""
    document.getElementById("cm-field-name").value = lead?.name || ""
    document.getElementById("cm-field-email").value = lead?.email || ""
    document.getElementById("cm-field-company").value = lead?.company || ""
    document.getElementById("cm-field-position").value = lead?.position || ""
    document.getElementById("cm-field-industry").value = lead?.industry || ""
    document.getElementById("cm-field-phone").value = lead?.phone || ""
    document.getElementById("cm-field-website").value = lead?.website || ""
    document.getElementById("cm-field-tags").value = lead?.tags || ""
    document.getElementById("cm-field-note").value = lead?.note || ""
    document.getElementById("cm-modal-error").style.display = "none"
    document.getElementById("cm-modal").classList.add("open")
  }

  _closeModal() {
    document.getElementById("cm-modal").classList.remove("open")
  }

  async _save() {
    const id = document.getElementById("cm-lead-id").value
    const data = {
      lead: {
        name: document.getElementById("cm-field-name").value,
        email: document.getElementById("cm-field-email").value,
        company: document.getElementById("cm-field-company").value,
        position: document.getElementById("cm-field-position").value,
        industry: document.getElementById("cm-field-industry").value,
        phone: document.getElementById("cm-field-phone").value,
        website: document.getElementById("cm-field-website").value,
        tags: document.getElementById("cm-field-tags").value,
        note: document.getElementById("cm-field-note").value
      }
    }
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const url = id ? `/coldmail/leads/${id}` : "/coldmail/leads"
    const method = id ? "PATCH" : "POST"

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
      body: JSON.stringify(data)
    })
    const json = await res.json()
    if (json.success) {
      if (id) {
        const idx = this._leads.findIndex(l => l.id === parseInt(id))
        if (idx >= 0) this._leads[idx] = json.lead
      } else {
        this._leads.unshift(json.lead)
      }
      this._applyFilters()
      this._closeModal()
    } else {
      const err = document.getElementById("cm-modal-error")
      err.textContent = json.errors?.join(", ") || this.msgSaveErrorValue
      err.style.display = "block"
    }
  }

  async _delete(id) {
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const res = await fetch(`/coldmail/leads/${id}`, {
      method: "DELETE",
      headers: { "X-CSRF-Token": csrf }
    })
    const json = await res.json()
    if (json.success) {
      this._leads = this._leads.filter(l => l.id !== id)
      this._selected.delete(id)
      this._applyFilters()
      this._updateBulkBar()
    }
  }

  async _import(file) {
    if (!file) return
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const fd = new FormData()
    fd.append("file", file)
    const res = await fetch("/coldmail/leads/import", {
      method: "POST",
      headers: { "X-CSRF-Token": csrf },
      body: fd
    })
    const json = await res.json()
    if (json.success) {
      alert(this._interpolate(this.msgImportSuccessValue, { count: json.count }))
      window.location.reload()
    } else {
      alert(json.errors?.join(", ") || this.msgImportErrorValue)
    }
  }

  async _bulkStatus() {
    const status = document.getElementById("cm-bulk-status")?.value
    if (!status || this._selected.size === 0) return
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const res = await fetch("/coldmail/leads/bulk_update", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
      body: JSON.stringify({ ids: [...this._selected], status })
    })
    const json = await res.json()
    if (json.success) {
      this._selected.forEach(id => {
        const lead = this._leads.find(l => l.id === id)
        if (lead) lead.status = status
      })
      this._selected.clear()
      this._applyFilters()
      this._updateBulkBar()
    }
  }

  async _bulkDelete() {
    if (this._selected.size === 0 || !confirm(this._interpolate(this.msgConfirmBulkDeleteValue, { count: this._selected.size }))) return
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const res = await fetch("/coldmail/leads/bulk_delete", {
      method: "DELETE",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
      body: JSON.stringify({ ids: [...this._selected] })
    })
    const json = await res.json()
    if (json.success) {
      const ids = [...this._selected]
      this._leads = this._leads.filter(l => !ids.includes(l.id))
      this._selected.clear()
      this._applyFilters()
      this._updateBulkBar()
    }
  }

  _esc(str) {
    return String(str || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }
}
